module.exports = __webpack_public_path__ + "img/4.243b8f4a.png";